export const passwordRegex = /^[A-Za-z0-9!@#$%^*]{6,40}$/;

export const getPasswordError = (password: string, repeat: string) => {
  if (!password || !repeat) {
    return 'Please enter and confirm your password.';
  }
  if (!passwordRegex.test(password)) {
    return 'Password must be 6-40 characters and use only letters, numbers, and ! @ # $ % ^ *.';
  }
  if (password !== repeat) {
    return 'Passwords do not match.';
  }
  return '';
};

export const getApiMessage = (data: any) => {
  if (!data) return '';
  if (typeof data === 'string') return data;
  return (
    data.message ||
    data.success?.message ||
    data.success ||
    data.status?.message ||
    data.error ||
    ''
  );
};
